import { ApostropheProvider } from '@apostrophe/ui';
import { fireClickyGoal } from 'helpers/analyticsHelpers';
import { get } from 'lodash';
import React, {
	createContext, useCallback, useEffect,useReducer
} from 'react';

import cartReducer, { emptyCart } from './reducer';

const CartContext = createContext();

const CheckoutProvider = props => {
	const isSync = get(props,
		'is_sync',
		false);
	let existing_payment_method = {}
	let google_shopping = false;
	if (props.existing_payments && props.existing_payments.defaultPaymentMethod) {
		existing_payment_method = props.existing_payments.defaultPaymentMethod
	}
	let promoCode = null;
	if (props.promo_code) {
		if (props.promo_code === 'FREECONSULTATION') {
			google_shopping = true;
		} else {
			promoCode = props.promo_code;
		}
	}
	const initState = {
		cart: emptyCart,
		consultationId: props.consultation_id,
		cadenceOption: props.cadenceOption,
		cadencePreference: props.cadencePreference,
		patient: props.patient,
		shipping: props.patient && props.patient.shipping,
		productOptions: [],
		cadenceOptions: [], // TODO: This is some weird old field. Not related to 2023 payment cadences.
		defaultPaymentMethod: existing_payment_method,
		CSRFToken: props.CSRFToken ? props.CSRFToken : props.client_token,
		patientId: props.patient ? props.patient.id : '',
		otcProducts: props.otc_product_options,
		businessLine: null,
		purchaseableProduct: null,
		promo: {
			discount_cents: 0,
			code: promoCode,
		},
		bodyBusy: false,
		doctorName: props.doctorName,
		type: props.type,
		crossSell: {
			version: '',
			stepNext: '',
			modalOpen: false,
		},
		isFollowup: props.isFollowup,
		google_shopping,
		isSync,
	}
	const memoizedReducer = useCallback(cartReducer,
		[])
	const [state, dispatch] = useReducer(memoizedReducer,
		initState);

	const setBodyBusy = (loading) => {
		dispatch({
			type: 'setBodyBusy',
			loading,
		})
	}

	const setCadenceOption = (cadenceOption) => (
		dispatch({
			type: 'setCadenceOption',
			cadenceOption,
		})
	)

	const setAutoShip = (productId, autoShip) => (
		dispatch({
			type: 'setAutoShip',
			productId,
			autoShip,
		})
	)

	const removeFromCart = (productId) => (
		dispatch({
			type: 'removeFromCart',
			productId,
		})
	);

	const changeOption = (productId, option) => {
		dispatch({
			type: 'addToCart',
			productId,
			option,
		})
	}

	const addToCart = (productId, option) => (
		dispatch({
			type: 'addToCart',
			productId,
			option,
		})
	);

	const updateDefaultPaymentMethod = (defaultPaymentMethod) => (
		dispatch({
			type: 'updateDefaultPaymentMethod',
			defaultPaymentMethod,
		})
	)

	const applyPromoToCart = (promoData) => {
		dispatch({
			type: 'applyPromoToCart',
			promoData: promoData,
		})
	}

	const removePromoFromCart = (promoCode, cookies) => {
		dispatch({
			type: 'removePromoFromCart',
			promoCode: promoCode,
			cookies: cookies,
		})
	}

	const setPromoData = (promoData) => {
		dispatch({
			type: 'setPromoData',
			promoData: promoData,
		})
	}

	const openCrossSell = (stepNext, version) => {
		dispatch({
			type: 'openCrossSell',
			stepNext,
			version,
		})
		// fire clicky goal for ab test viewed (don't care which version)
		fireClickyGoal({ clicky_goal_id: 'RET FILI Cross-sell Viewed' })
	}

	const closeCrossSell = () => {
		dispatch({ type: 'closeCrossSell' })
	}


	useEffect(() => {
		if (!props.skipCart) {
			dispatch({
				type: 'setupCart',
				props,
			})
			dispatch({ type: 'updateCartTotal' })
		}

	},
	[])

	const dispatcher = {
		setBodyBusy,
		removeFromCart,
		setCadenceOption,
		setAutoShip,
		changeOption,
		updateDefaultPaymentMethod,
		applyPromoToCart,
		removePromoFromCart,
		setPromoData,
		openCrossSell,
		closeCrossSell,
		addToCart,
	}

	return (
		<CartContext.Provider value={{
			state,
			dispatcher,
		}}>
			<ApostropheProvider>
				{props.children}
			</ApostropheProvider>
		</CartContext.Provider>
	);
}
const { Consumer } = CartContext;
export {
	CartContext,CheckoutProvider, Consumer as default,
};
